<template>
  <div>
    <div v-if="selectedKey === 'key_4'">
      <key-four :status_key="'key_4'" />
    </div>
    <div v-if="selectedKey === 'key_5'">
      <key-five :status_key="'key_5'" />
    </div>
    <div v-if="selectedKey === 'key_6'">
      <key-common
        :key="selectedKey"
        :status_key="'key_6'"
        date_filter_key="status_date"
        date_filter_name="Assigned Date"
        status_name="PickedUp"
      />
    </div>
    <div v-if="selectedKey === 'key_7'">
      <key-seven :status_key="'key_7'" />
    </div>
    <div v-if="selectedKey === 'key_8'">
      <key-common
        :key="selectedKey"
        :status_key="'key_8'"
        date_filter_key="status_date"
        date_filter_name="Picked Up Date"
        status_name="DispatchToOriginWarehouse"
      />
    </div>
    <div v-if="selectedKey === 'key_9'">
      <key-nine :status_key="'key_9'" />
    </div>
    <div v-if="selectedKey === 'key_24'">
      <key-return-common
        :key="selectedKey"
        :status_key="'key_24'"
        date_filter_key="status_date"
        date_filter_name="Dispatched Date"
        status_name="ReceiveReturnFromPickupWarehouse"
      />
    </div>
    <div v-if="selectedKey === 'key_25'">
      <key-twenty-five
        :key="selectedKey"
        :status_key="'key_25'"
        date_filter_key="status_date"
        date_filter_name="Assigned Date"
        status_name="AssignToReturnRider"
      />
    </div>
    <div v-if="selectedKey === 'key_30'">
      <key-thirty
        :key="selectedKey"
        :status_key="'key_30'"
        date_filter_key="orders.created_at"
        date_filter_name="Created Date"
        status_name="ReturnedToMerchant"
      />
    </div>
    <div v-if="selectedKey === 'key_31'">
      <key-thirty-one
        :key="selectedKey"
        :status_key="'key_31'"
        date_filter_key="status_date"
        date_filter_name="Returned Date"
        status_name="returnToPickupWarehouse(FailedToReturn)"
      />
    </div>
    <div v-if="selectedKey === 'key_32'">
      <key-common
        :key="selectedKey"
        :status_key="'key_32'"
        date_filter_key="status_date"
        date_filter_name="Returned Date"
        status_name="receivedFromPickupWarehouse(FailedToReturn)"
      />
    </div>
    <div v-if="selectedKey === 'key_33'">
      <key-thirty-three
        :key="selectedKey"
        :status_key="'key_33'"
        date_filter_key="status_date"
        date_filter_name="Returned Date"
        status_name="rescheduleReturn"
      />
    </div>
    <div v-if="selectedKey === 'key_34'">
      <key-common
        :key="selectedKey"
        :status_key="'key_34'"
        date_filter_key="status_date"
        date_filter_name="Dispatched Date"
        status_name="DispatchedToSortingWarehouse"
      />
    </div>
    <div v-if="isCustomStatus">
      <key-custom
        :status_key="selectedKey"
        :status_actions="statusOptions.actions"
        :status_name="statusOptions.name"
      />
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/extensions,camelcase
import Ripple from 'vue-ripple-directive'
// eslint-disable-next-line import/extensions
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import KeyFour from '../../components/status-flow/KeyFour.vue'
import KeyFive from '../../components/status-flow/KeyFive.vue'
import KeyNine from '../../components/status-flow/KeyNine.vue'
import KeyCommon from '../../components/status-flow/KeyCommon.vue'
import KeyTwentyFive from '../../components/status-flow/KeyTwentyFive.vue'
import KeySeven from '../../components/status-flow/KeySeven.vue'
import KeyThirty from '../../components/status-flow/KeyThirty.vue'
import KeyThirtyOne from '../../components/status-flow/KeyThirtyOne.vue'
import KeyThirtyThree from '../../components/status-flow/KeyThirtyThree.vue'
import KeyReturnCommon from '../../components/status-flow/KeyReturnCommon.vue'
import KeyCustom from '../../components/status-flow/KeyCustom.vue'

const OrderRepository = RepositoryFactory.get('order')

export default {
  directives: {
    Ripple,
  },
  components: {
    KeyFour,
    KeyFive,
    KeyNine,
    KeyCommon,
    KeyTwentyFive,
    KeyThirty,
    KeyThirtyOne,
    KeyThirtyThree,
    KeySeven,
    KeyReturnCommon,
    KeyCustom,
  },
  data() {
    return {
      selectedKey: '',
      selectedId: null,
      statusOptions: [],
    }
  },
  computed: {
    isCustomStatus() {
      return this.selectedKey.startsWith('cus_')
    },
  },
  mounted() {
    this.getKey()
  },
  methods: {
    getKey() {
      this.selectedKey = this.$route.params.key
      this.selectedId = this.$route.params.id
      if (this.isCustomStatus) {
        this.fetchStatusDetails()
      }
    },
    async fetchStatusDetails() {
      try {
        const { data } = (await OrderRepository.updateStatusId(this.selectedId)).data
        this.statusOptions = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
  },
}
</script>

<style lang="scss">
@import 'src/@core/scss/vue/libs/vue-select';
</style>
